import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { WindowNames } from "@resources/constants";

import { fetchAuth, fetchReg, fetchRequestCode} from "./asyncActions";
import { getSendCodeErrorMessage } from "@/utils/sendCodeError";

import { IAuthAndReg, IRespData } from "./types";

const initialState: IAuthAndReg = {
  auth: false,
  isLoading: false,
  showWindow: "",
  errorMessage: "",
};

const authAndRegSlice = createSlice({
  name: "authAndReg",
  initialState,
  reducers: {
    setAuth(state, action: PayloadAction<string | null>) {
      state.auth = action.payload ? true : false;
    },
    setShowWindow(state, action: PayloadAction<string>) {
      state.showWindow = action.payload;
    },
    resetShowWindow(state) {
      state.showWindow = "";
    },
    clearErrorMessage(state) {
      state.errorMessage = "";
    },
  },
  extraReducers: (builder) => {
    // auth
    builder
      .addCase(fetchAuth.pending, (state) => {
        state.isLoading = true;
        state.errorMessage = "";
      })
      .addCase(fetchAuth.fulfilled, (state, action: PayloadAction<IRespData>) => {
        state.isLoading = false;
        state.auth = action.payload.auth ? true : false;
        if (action.payload.showWindow) state.showWindow = action.payload.showWindow;
      })
      .addCase(fetchAuth.rejected, (state, action) => {
        state.isLoading = false;
        state.auth = false;
        state.errorMessage = typeof action.payload === "string" 
          ? action.payload 
          : action.error?.message || "Ошибка авторизации";
      })
    
    // reg
    builder
      .addCase(fetchReg.pending, (state) => {
        state.isLoading = true;
        state.errorMessage = "";
      })
      .addCase(fetchReg.fulfilled, (state) => {
        state.isLoading = false;
        state.errorMessage = "";
      })
      .addCase(fetchReg.rejected, (state, action) => {
        state.isLoading = false;
        const errorMessage = typeof action.payload === "string" 
          ? action.payload 
          : action.error?.message || "Ошибка регистрации";
        
        if (errorMessage.includes("Email") && errorMessage.includes("already registered")) {
          state.errorMessage = "Пользователь с таким email уже существует";
        } else if (errorMessage.includes("Phone") && errorMessage.includes("already registered") || errorMessage.includes("уже существует")) {
          state.errorMessage = "Пользователь с данным номером уже существует";
        } else if (errorMessage.includes("already registered")) {
          state.errorMessage = "Пользователь уже зарегистрирован";
        } else if (errorMessage.includes("Not allowed")) {
          state.errorMessage = "В данный момент сервис недоступен, просьба повторить попытку через 1 минуту";
        } else {
          // signup — это и есть отправка кода: любой другой сбой = код не ушёл
          state.errorMessage = getSendCodeErrorMessage(errorMessage);
        }
      });
      
    // code apply
    builder
      .addCase(
        fetchRequestCode.pending,
        (state) => {
          state.isLoading = true;
        }
      )
      .addCase(
        fetchRequestCode.fulfilled,
        (state) => {
          state.isLoading = false;
          state.auth = true;
        }
      )
      .addCase(
        fetchRequestCode.rejected,
        (state) => {
          state.isLoading = false;
          state.showWindow = WindowNames.ERROR;
        }
      );
  },
});

export const { setAuth, setShowWindow, resetShowWindow, clearErrorMessage } = authAndRegSlice.actions;

export default authAndRegSlice.reducer;
